import { useState } from "react";
import type { RefillSummaryData } from "slices/refillSummarySelectors";
import { RefillSummarySection, type RefillSummaryVariant } from "./RefillSummarySection";

// A local refill's two accordions, Added and Removed: shown while it runs (step 3) and in its summary (step 5).
// Both start collapsed, showing their totals. One is open at a time, so the open list gets the whole body to
// scroll in; tapping the open header closes it again.
export const RefillSummarySections = ({ summary }: { summary: RefillSummaryData }) => {
	const [openSection, setOpenSection] = useState<RefillSummaryVariant | null>(null);
	const toggleSection = (variant: RefillSummaryVariant) => {
		setOpenSection((current) => (current === variant ? null : variant));
	};

	return (
		<>
			<RefillSummarySection
				variant="added"
				section={summary.added}
				expanded={openSection === "added"}
				onToggle={() => toggleSection("added")}
			/>
			<RefillSummarySection
				variant="removed"
				section={summary.removed}
				expanded={openSection === "removed"}
				onToggle={() => toggleSection("removed")}
			/>
		</>
	);
};
